import { useState } from "react";
import { Star } from "lucide-react";

export function StarDisplay({ value = 0, count, size = "h-3.5 w-3.5", testid }) {
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1">
      <span className="inline-flex">
        {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-[#FC5106] text-[#FC5106]" : "text-[#3915AA]/20"}`} />)}
      </span>
      {count !== undefined && <span className="text-xs font-semibold text-[#5E5675]">{value ? value.toFixed(1) : ""} ({count})</span>}
    </span>
  );
}

export function StarInput({ value, onChange, disabled, testid, size = "h-6 w-6" }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value || 0;
  return (
    <span data-testid={testid} className="inline-flex" onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" disabled={disabled} onMouseEnter={() => setHover(i)} onClick={() => onChange(i)} aria-label={`Rate ${i} star${i > 1 ? "s" : ""}`} data-testid={`${testid}-${i}`}
          className="p-0.5 transition-transform hover:scale-110 disabled:opacity-50">
          <Star className={`${size} ${i <= shown ? "fill-[#FC5106] text-[#FC5106]" : "text-[#3915AA]/25"}`} />
        </button>
      ))}
    </span>
  );
}
